<template>
    <div class="table-wrapper">
        <export-csv-button :trigger="export_csv.trigger" :title="export_csv.title"
            :rows="export_csv.rows"></export-csv-button>
        <v-data-table :loading="loader" disable-initial-sort :rows-per-page-items="rowPerPage" :headers="headers"
            :items="filtered_items" item-key="id" class="compact-table">
            <template #headers="props">
                <tr>
                    <th :class="['fw-bold', `text-xs-${header.align}`]" :style="{ width: header.width }"
                        v-for="header in props.headers" :key="header.text">
                        {{ header.text }}
                    </th>

                </tr>
            </template>
            <template #items="props">
                <tr>
                    <td class="text-center text-no-wrap"
                        v-if="props.item.registration_status === INTERNET_REGISTRATION_STATUS.PENDING">
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on">
                                    <v-icon small color="#464D69">settings</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile @click="openDialog(props.item, 'cancel')"
                                    v-if="props.item.registration_status === INTERNET_REGISTRATION_STATUS.PENDING">
                                    <v-list-tile-action>
                                        <v-icon small class="zmdi zmdi-close-circle"></v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-title>Hủy đăng ký</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile @click="openDialog(props.item, 'edit')"
                                    v-if="props.item.registration_status === INTERNET_REGISTRATION_STATUS.PENDING">
                                    <v-list-tile-action>
                                        <v-icon small class="zmdi zmdi-edit"></v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-title>Chỉnh sửa</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile @click="openDialog(props.item, 'delete')"
                                    v-if="props.item.registration_status === INTERNET_REGISTRATION_STATUS.PENDING">
                                    <v-list-tile-action>
                                        <v-icon small class="zmdi zmdi-delete"></v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-title>Xóa</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </td>
                    <td v-else></td>
                    <td class="text-center text-no-wrap">{{ props.item.building_text }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.room_id }}</td>
                    <td class="text-center text-no-wrap">
                        <span
                            :class="['v-badge', internet_registration_badges[props.item.registration_status] ? internet_registration_badges[props.item.registration_status].badge : '']">{{
                                INTERNET_REGISTRATION_STATUS_LABEL_DISPLAYING[props.item.registration_status] ||
                                props.item.registration_status }}</span>
                    </td>
                    <td class="text-center text-no-wrap">{{ props.item.receipt_id }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.registration_date | formatTimeServer }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.date_start | formatTimeServer }}
                    </td>
                    <td class="text-center text-no-wrap">{{ props.item.user || '' }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.customer_price | formatNumber }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.number_of_residents }}</td>
                    <td class="text-center text-no-wrap">
                        <span
                            :class="['v-badge', wifi_type_badges[props.item.wifi_type] ? wifi_type_badges[props.item.wifi_type].badge : '']">{{
                                wifi_type_badges[props.item.wifi_type] ? wifi_type_badges[props.item.wifi_type].text :
                                    (props.item.wifi_type ||
                                        '') }}</span>
                    </td>
                    <td style="cursor: pointer; max-width: 200px; word-wrap: break-word; word-break: break-word; white-space: normal;" class="text-center">
                        <v-edit-dialog
                            large
                            lazy
                            @save="updateInstallationPlan(props.item)"
                            @open="props.item.new_installation_plan = props.item.installation_plan"
                        >
                            <div style="max-width: 200px; white-space: normal; word-wrap: break-word; word-break: break-word;">
                                {{ props.item.installation_plan || '' }}
                            </div>
                            <template v-slot:input>
                                <v-text-field
                                    v-model="props.item.new_installation_plan"
                                    label="Phương án"
                                    single-line
                                ></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </td>
                </tr>
            </template>
            <template #no-data>Chưa có thông tin</template>
        </v-data-table>

        <!-- Dialog chỉnh sửa đăng ký -->
        <edit-internet-registration :internet_user="chosen_internet_user" :dialog="edit_dialog"
            @close="edit_dialog = false" @reload="getData" />
    </div>
</template>

<script>
import api from "Api";
import { list_building, WIFI_TYPE_BADGES, WIFI_TYPE_OPTIONS } from "Constants/db-config";
import { formatTimeServer, buildParamQuery } from "Helpers";
import ExportCsvButton from "Components/ExportExcel/ExportCsvButton";
import EditInternetRegistration from "./EditInternetRegistration";
import ActivateInternetDialog from "./ActivateInternet";
import { INTERNET_REGISTRATION_STATUS, INTERNET_REGISTRATION_STATUS_LABEL_DISPLAYING } from "Constants/db-config";

export default {
    props: {
        reload_table: Number,
        search: String,
        chosen_building: String,
        exportCSV: Number,
        filterRegistrationStatus: {
            type: String,
            default: null
        }
    },
    components: {
        ExportCsvButton,
        EditInternetRegistration,
        ActivateInternetDialog
    },
    name: "internet-registration-table",
    data() {
        return {
            list_building,
            headers: [
                { text: "Thao tác", align: "center", sortable: false, width: "80px" },
                {
                    text: "Tòa nhà",
                    align: "center",
                    sortable: true,
                    value: "building",
                    width: "80px"
                },
                {
                    text: "Phòng",
                    align: "center",
                    sortable: true,
                    value: "room_id",
                    width: "80px"
                },
                {
                    text: "Trạng thái",
                    align: "center",
                    sortable: true,
                    value: "status",
                    width: "130px"
                },
                {
                    text: "Số phiếu",
                    align: "center",
                    sortable: true,
                    value: "receipt_id",
                    width: "80px"
                },
                {
                    text: "Ngày đăng ký",
                    align: "center",
                    sortable: true,
                    value: "registration_date",
                    width: "110px"
                },
                {
                    text: "Ngày thực tế lắp",
                    align: "center",
                    sortable: true,
                    value: "date_start",
                    width: "110px"
                },
                {
                    text: "User",
                    align: "center",
                    sortable: true,
                    value: "user",
                    width: "240px"
                },
                {
                    text: "Giá thu KH",
                    align: "center",
                    sortable: true,
                    value: "customer_price",
                    width: "120px"
                },
                {
                    text: "Số người ở",
                    align: "center",
                    sortable: true,
                    value: "number_of_residents",
                    width: "80px"
                },
                {
                    text: "Wifi",
                    align: "center",
                    sortable: true,
                    value: "wifi_type",
                    width: "80px"
                },
                {
                    text: "Phương án",
                    align: "center",
                    sortable: true,
                    value: "installation_plan",
                    width: "200px"
                },
            ],
            items: [],
            loader: false,
            rowPerPage: [50, 100, 200, { text: "Tất cả", value: -1 }],
            chosen_internet_user: {},
            edit_dialog: false,

            wifi_types: WIFI_TYPE_OPTIONS,
            export_csv: {
                loading: false,
                trigger: false,
                title: "",
                rows: []
            },
            wifi_type_badges: WIFI_TYPE_BADGES,
            internet_registration_badges: {
                [INTERNET_REGISTRATION_STATUS.PENDING]: {
                    badge: "info"
                },
                [INTERNET_REGISTRATION_STATUS.CANCELLED]: {
                    badge: "error"
                },
                [INTERNET_REGISTRATION_STATUS.ACTIVE]: {
                    badge: "success"
                },
                [INTERNET_REGISTRATION_STATUS.CUT]: {
                    badge: "success"
                },
                [INTERNET_REGISTRATION_STATUS.STOP]: {
                    badge: "success"
                }
            },
            INTERNET_REGISTRATION_STATUS,
            INTERNET_REGISTRATION_STATUS_LABEL_DISPLAYING
        };
    },
    computed: {
        filtered_items() {
            const search = this.search && this.search.toLowerCase();
            return this.items.filter(item => {
                if (item.is_old_data) {
                    return false;
                }
                // Filter by building
                if (this.chosen_building && (!item.building || item.building !== this.chosen_building)) {
                    return false;
                }
                // Filter by search
                if (search) {
                    if (item.room_id && item.room_id.toLowerCase().includes(search)) {
                        return true;
                    }
                    if (item.user && item.user.toLowerCase().includes(search)) {
                        return true;
                    }
                    return false;
                }
                // Filter by registration status
                const itemRegistrationStatusDisplaying = INTERNET_REGISTRATION_STATUS_LABEL_DISPLAYING[item.registration_status];
                if (this.filterRegistrationStatus !== null && itemRegistrationStatusDisplaying !== this.filterRegistrationStatus) {
                    return false;
                }
                return true;
            });
        },

        rooms() {
            return this.$store.state.app.rooms.concat([
                { room_id: 'tang-ham-gb', building: "GB" },
                { room_id: 'tang-ham-tt', building: "TT" },
                { room_id: 'tang-ham-ma', building: "MA" },
                { room_id: 'tang-ham-xa', building: "XA" },
                { room_id: 'tang-ham-bn', building: "BN" }
            ]);
        },
        room_ids() {
            return this.rooms.filter(room => room.building === this.chosen_internet_user.building);
        }
    },
    watch: {
        reload_table() {
            this.getData();
        },
        exportCSV() {
            this.startExportCSV();
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        getItemStatus: function (item) {
            if (!item.room_state_id) return 0;
            else if (!item.date_schedule_out) return 1;
            return 2;
        },
        getData: async function () {
            this.items = [];
            this.loader = true;
            try {
                const params = { getValidAndNotValid: true };
                const query = buildParamQuery(params);
                let data = await api.getListInternet(query);
                this.loader = false;

                if (data.status === 200 && data.data && data.data.internet) {
                    this.items = data.data.internet
                        .filter(item => !item.is_old_data)
                        .map(item => {
                            if (item.registration_status) return item;
                            const status = this.getItemStatus(item);
                            if (!item.is_valid) return {...item, registration_status: INTERNET_REGISTRATION_STATUS.CUT};
                            if (status === 0) return {...item, registration_status: INTERNET_REGISTRATION_STATUS.CUT};
                            if (status === 1) return {...item, registration_status: INTERNET_REGISTRATION_STATUS.ACTIVE};
                            if (status === 2) return {...item, registration_status: INTERNET_REGISTRATION_STATUS.CANCELLED};
                            return {...item, registration_status: INTERNET_REGISTRATION_STATUS.ACTIVE};
                        })
                        .map(item => {
                            const building = list_building.find(
                                building => building.value == item.building
                            );
                            item.building_text = building ? building.text : item.building;

                            if (!item.number_of_residents) item.number_of_residents = 1;

                            return item;
                        })
                        .sort((a, b) => {
                            const dateA = a.registration_date ? new Date(a.registration_date) : (a.createdAt ? new Date(a.createdAt) : new Date(0));
                            const dateB = b.registration_date ? new Date(b.registration_date) : (b.createdAt ? new Date(b.createdAt) : new Date(0));
                            return dateB - dateA;
                        });
                } else {
                    console.log("Lỗi lúc tải internet registration:", data);
                }
            } catch (error) {
                this.loader = false;
                console.error("Lỗi getData:", error);
            }
        },
        openDialog(internet_user, action) {
            // Đóng tất cả modal trước khi mở modal mới
            this.closeAllDialogs();

            this.chosen_internet_user = { ...internet_user };

            if (action === 'cancel') {
                this.cancelRegistration(internet_user);
            } else if (action === 'edit') {
                this.editRegistration(internet_user);
            } else if (action === 'delete') {
                this.deleteRegistration(internet_user);
            }
        },
        async cancelRegistration(internet_user) {
            try {
                const data = await api.cancelRegistration({
                    _id: internet_user._id,
                });

                if (data.status === 200) {
                    swal.fire('Thành công', 'Đã hủy đăng ký', 'success');
                    this.getData();
                } else {
                    swal.fire('Lỗi', data.message || 'Có lỗi xảy ra', 'error');
                }
            } catch (error) {
                console.error("Cancel error:", error);
                swal.fire('Lỗi', 'Có lỗi xảy ra khi hủy', 'error');
            }
        },
        editRegistration(internet_user) {
            const user = { ...internet_user };
            if (user.date_start) user.date_start = user.date_start.substring(0, 10);
            if (user.registration_date) user.registration_date = user.registration_date.substring(0, 10);
            if (user.date_start) user.date_start = user.date_start.substring(0, 10);
            if (user.renewal_start_date) user.renewal_start_date = user.renewal_start_date.substring(0, 10);
            if (user.renewal_end_date) user.renewal_end_date = user.renewal_end_date.substring(0, 10);

            if (user.receipt_code) user.receipt_code = user.receipt_code;

            this.closeAllDialogs();

            this.chosen_internet_user = user;
            this.edit_dialog = true;
        },
        closeAllDialogs() {
            this.edit_dialog = false;
        },
        deleteRegistration(internet_user) {
            swal.fire({
                title: 'Xác nhận xóa',
                text: `Bạn có chắc muốn xóa đăng ký Internet?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Xóa',
                cancelButtonText: 'Hủy'
            }).then((result) => {
                if (result.value) {
                    this.confirmDelete(internet_user);
                }
            });
        },
        async confirmDelete(internet_user) {
            try {
                await api.updateInternet(internet_user._id, {
                    is_valid: false,
                    note: 'Xóa từ bảng đăng ký lắp mạng'
                });

                swal.fire('Thành công', 'Đã xóa đăng ký Internet', 'success');
                this.getData();
            } catch (error) {
                console.error("Delete error:", error);
                swal.fire('Lỗi', 'Có lỗi xảy ra khi xóa', 'error');
            }
        },
        async updateInstallationPlan(item) {
            try {
                await api.updateInternet(item._id, {
                    installation_plan: item.new_installation_plan
                });
                item.installation_plan = item.new_installation_plan;
            } catch (error) {
                console.error("Update installation plan error:", error);
                swal.fire('Lỗi', 'Có lỗi xảy ra khi cập nhật phương án', 'error');
            }
        },
        startExportCSV() {
            if (this.filtered_items.length === 0) {
                swal.fire('Thông báo', 'Không có dữ liệu để xuất Excel', 'info');
                return;
            }

            const XLSX = require('xlsx');

            const rows = this.filtered_items.map(item => {
                return {
                    "Tòa nhà": item.building_text,
                    "Phòng": item.room_id,
                    "Trạng thái": INTERNET_REGISTRATION_STATUS_LABEL_DISPLAYING[item.registration_status],
                    "Số phiếu": item.receipt_id,
                    "Ngày đăng ký": formatTimeServer(item.registration_date),
                    "Ngày thực tế lắp": formatTimeServer(item.date_start),
                    "User": item.user || '',
                    "Giá thu khách hàng": item.customer_price,
                    "Số người ở": item.number_of_residents,
                    "Wifi": this.wifi_type_badges[item.wifi_type] ? this.wifi_type_badges[item.wifi_type].text : (item.wifi_type || ''),
                    "Phương án": item.installation_plan || '',
                };
            });

            // Tạo workbook và worksheet
            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.json_to_sheet(rows);

            // Tô màu header
            const headerRange = XLSX.utils.decode_range(ws['!ref']);
            for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
                const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
                if (!ws[cellAddress]) ws[cellAddress] = { v: '' };
                ws[cellAddress].s = {
                    fill: { fgColor: { rgb: "4472C4" } },
                    font: { color: { rgb: "FFFFFF" }, bold: true },
                    alignment: { horizontal: "center", vertical: "center" }
                };
            }

            // Tô màu dữ liệu xen kẽ
            for (let row = 1; row <= headerRange.e.r; row++) {
                for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
                    const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
                    if (!ws[cellAddress]) ws[cellAddress] = { v: '' };

                    if (row % 2 === 0) {
                        ws[cellAddress].s = {
                            fill: { fgColor: { rgb: "F2F2F2" } },
                            alignment: { horizontal: "center", vertical: "center" }
                        };
                    } else {
                        ws[cellAddress].s = {
                            fill: { fgColor: { rgb: "FFFFFF" } },
                            alignment: { horizontal: "center", vertical: "center" }
                        };
                    }
                }
            }

            // Auto-fit columns
            const colWidths = [];
            for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
                let maxWidth = 10;
                for (let row = 0; row <= headerRange.e.r; row++) {
                    const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
                    if (ws[cellAddress] && ws[cellAddress].v) {
                        const cellValue = String(ws[cellAddress].v);
                        maxWidth = Math.max(maxWidth, cellValue.length);
                    }
                }
                colWidths.push({ wch: maxWidth + 2 });
            }
            ws['!cols'] = colWidths;

            // Thêm worksheet vào workbook
            XLSX.utils.book_append_sheet(wb, ws, "Đăng ký lắp mạng");

            // Xuất file
            const date = new Date().toISOString().substring(0, 10);
            XLSX.writeFile(wb, `dang-ky-lap-mang-${date}.xlsx`);
        },

    }
};
</script>

<style scoped>
.table-wrapper {
    width: 100%;
    overflow-x: auto;
    max-width: 100%;
}

.v-list__tile__action {
    min-width: 30px;
}

.compact-table {
    table-layout: fixed !important;
    width: 100% !important;
    max-width: 100% !important;
}

.compact-table>>>.v-datatable__wrapper {
    overflow-x: hidden !important;
    max-width: 100% !important;
}

.compact-table>>>table {
    table-layout: fixed !important;
    width: 100% !important;
    max-width: 100% !important;
}

</style>